import clsx from "clsx";
import type { NamedExoticComponent, PropsWithChildren } from "react";
import { memo } from "react";

import classes from "./styles.module.scss";

import type { IPageProps } from "@components/atoms/page/types";

const Page = memo(function Page({ children }: IPageProps) {
  return <div className={clsx(classes.page)}>{children}</div>;
}) as NamedExoticComponent<IPageProps> & {
  Row: NamedExoticComponent<PropsWithChildren>;
};

const Row = memo(function Row({ children }: PropsWithChildren) {
  return <div className={clsx(classes.page__row)}>{children}</div>;
});

Page.Row = Row;

export { Page };
